/**
 * External legal document links.
 *
 * Termly-hosted privacy policy and terms of service URLs, linked from the
 * sign-up/log-in page and the user homepage.
 */
export const privacyPolicyLink =
    "https://app.termly.io/policy-viewer/policy.html?policyUUID=560284e8-71a3-4773-8583-48e123c89978";
export const termsOfServiceLink =
    "https://app.termly.io/policy-viewer/policy.html?policyUUID=4080c0fa-965b-4c3f-9611-de44e626a9b0";
